import React from 'react';
import {z} from 'zod';

import {ImageOutlined} from '@mui/icons-material';

import {Image,ImagePropsSchema} from './Image';
import ImageSidebarPanel from './ImageSidebarPanel';

export type ImageProps = z.infer<typeof ImagePropsSchema>;

export default {
    label: 'Image',
    icon: <ImageOutlined />,
    type: 'Image',
    defaultData: {
        props: {
            url: 'https://assets.usewaypoint.com/sample-image.jpg',
            alt: 'Sample product',
            contentAlignment: 'middle',
            linkHref: null,
        },
        style: { padding: { top: 16, bottom: 16, left: 24, right: 24 } },
    },
    SidebarPanel: ImageSidebarPanel,
    Component: Image,
    schema: ImagePropsSchema,
};